import { render, staticRenderFns } from "./appointment-form.vue?vue&type=template&id=7b25acf6"
import script from "./appointment-form.vue?vue&type=script&lang=js"
export * from "./appointment-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports